Postlogin.Lesson = (function (my) {
    my.WordScramble = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container = null;
        const numberOfLetters = Object.keys(me.options).length;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfLetters);

            // add the question to the page
            if (me.activity_data.question_text) {
                const question = $('<div class="question"></div>');
                if (me.activity_data.question_audio) {
                    question.attr('data-audio', me.activity_data.question_audio);
                }
                if (me.activity_data.question_text) {
                    const questionText = $(`<h2 class="question-title">${me.activity_data.question_text}</h2>`);
                    question.append(questionText);
                }
                const checkContainer = $('<div class="check-container"></div>');

                const wordButton = $('<button class="hear-word"><i class="fa fa-volume-up" aria-hidden="true"></i> Hear Word</button>');
                // speaks the audio for the question when clicked
                wordButton.on('click', () => {
                    me.speakQuestion();
                });

                const checkButton = $(
                    '<button class="check-order"><i class="fa fa-check-circle" aria-hidden="true"></i> Check Answer</button>',
                );
                checkButton.on('click', checkCorrectness);

                checkContainer.append(wordButton);
                checkContainer.append(checkButton);

                question.append(checkContainer);
                segmentContainer.append(question);
            }

            const slots = $('<ul></ul>').addClass('slots');
            let order = 1;

            $.each(me.options, (i, option) => {
                const slot = $('<li></li>');
                slot.addClass('slot');
                slot.attr('data-letter', option.answer);
                slot.attr('data-order', order);
                if (option.correct) {
                    slot.addClass('pre-placed placed');
                }

                const letter = $(`<div><span>${option.answer}</span></div>`);
                letter.addClass('letter');
                letter.attr('data-letter', option.answer);
                letter.attr('data-order', order);
                if (option.correct) {
                    letter.addClass('correct');
                } else {
                    letter.addClass('draggable');
                }

                slot.append(letter);
                slots.append(slot);
                order++;
            });

            segmentContainer.append(slots);
            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);

            $(container)
                .find('.slots li > .letter.draggable')
                .each((i, p) => {
                    randomizePiece($(p));

                    $(p).draggable({
                        cursor: 'grabbing',
                        containment: `#${containerId}`,
                        scroll: false,
                        start() {
                            const piece = $(this);
                            piece.removeClass('placed incorrect correct');
                            piece.css('cursor', 'grabbing');
                            Postlogin.Lesson.playSoundEffect('pick_up', 0.1);
                            const slotIndex = piece.attr('data-in-slot');
                            piece.attr('data-in-slot', '');
                            if (typeof slotIndex !== 'undefined' && $.isNumeric(slotIndex)) {
                                $(container).find(`.slots > li[data-order=${slotIndex}]`).removeClass('placed');
                            }
                            $(container).find('.check-order').removeClass('animated pulse_wait infinite');
                        },
                        stop(event, ui) {
                            const piece = $(this);
                            const pieceIndex = parseInt($(this).attr('data-order'), 10);

                            const pieceWidth = $(piece).width();
                            const pieceHeight = $(piece).height();
                            const pieceOffsetTop = Math.round(ui.offset.top);
                            const pieceOffsetLeft = Math.round(ui.offset.left);

                            // see if piece is directly above a slot
                            $(container)
                                .find('.slots > li:not(.placed)')
                                .each(function () {
                                    const slot = $(this);
                                    const slotIndex = parseInt(slot.attr('data-order'), 10);
                                    const offset = slot.offset();
                                    const slotTop = Math.round(offset.top);
                                    const slotLeft = Math.round(offset.left);
                                    if (
                                        Math.abs(pieceOffsetTop - slotTop) <= pieceHeight / 2
                                        && Math.abs(pieceOffsetLeft - slotLeft) <= pieceWidth / 2
                                    ) {
                                        if (slotIndex > pieceIndex) {
                                            piece.css(
                                                'left',
                                                `calc(${(slotIndex - pieceIndex) * 100}% + ${10 * (slotIndex - pieceIndex)}px)`,
                                            );
                                            piece.css('top', '0px');
                                        } else if (pieceIndex > slotIndex) {
                                            piece.css(
                                                'left',
                                                `calc(-${(pieceIndex - slotIndex) * 100}% - ${10 * (pieceIndex - slotIndex)}px)`,
                                            );
                                            piece.css('top', '0px');
                                        } else {
                                            piece.css('left', '0px');
                                            piece.css('top', '0px');
                                        }
                                        Postlogin.Lesson.playSoundEffect('click');

                                        piece.addClass('placed');
                                        slot.addClass('placed');
                                        piece.attr('data-in-slot', slotIndex);

                                        if (slot.attr('data-letter') === piece.attr('data-letter')) {
                                            piece.addClass('correct');
                                        } else {
                                            piece.addClass('incorrect');
                                        }

                                        if ($(container).find('.slots li.placed').length === +numberOfLetters) {
                                            $(container).find('.check-order').addClass('animated pulse_wait infinite');
                                        }

                                        return false;
                                    }
                                });
                        },
                    });
                });

            $(container).on('mousedown', '.slots li > .letter', function (e) {
                e.originalEvent.preventDefault();
                $(this).css('cursor', 'grabbing');
                $(this).addClass('grabbing');
            });

            $(container).on('mouseup', '.slots li > .letter', function (e) {
                $(this).removeClass('grabbing');
                e.originalEvent.preventDefault();
            });
        };

        const checkCorrectness = function () {
            // wait a short time between showing correct and incorrect placements
            const waitTime = $(container).find('.letter.placed.correct').length < 1 ? 100 : 500;
            let numberCorrect = 0;
            let numberIncorrect = 0;

            // for each letter that is placed correctly...
            $(container)
                .find('.letter.placed.correct.draggable')
                .each((index, letter) => {
                    $(letter).removeClass('draggable');
                    $(letter).draggable('disable');
                    Postlogin.Lesson.playSoundEffect('placing');
                    numberCorrect++;
                });
            // and now for each letter that is placed incorrectly
            setTimeout(() => {
                $(container)
                    .find('.letter.placed.incorrect')
                    .each((index, letter) => {
                        const slot = $(letter).attr('data-in-slot');
                        randomizePiece($(letter), true);
                        $(container).find(`.slots > li[data-order=${slot}]`).removeClass('placed');
                        $(letter).removeClass('placed incorrect');
                        $(letter).addClass('animated shake');
                        Postlogin.Lesson.playSoundEffect('incorrect');
                        numberIncorrect++;
                        setTimeout(() => {
                            $(letter).removeClass('animated shake');
                        }, 500);
                    });

                if (+numberCorrect === 0 && +numberIncorrect === 0) {
                    Postlogin.Lesson.playSoundEffect('error-buzz');
                    $(container).find('.slot:not(.placed)').addClass('animated flash');
                    setTimeout(() => {
                        $(container).find('.slot:not(.placed)').removeClass('animated flash');
                    }, 500);
                }

                $(container).find('.check-order').removeClass('animated pulse_wait infinite');

                if ($(container).find('.slots > li > .letter.correct').length === +numberOfLetters) {
                    setTimeout(() => {
                        $(container).find('.slots > li > .letter.correct').addClass('glow-text');
                        Postlogin.Lesson.playSoundEffect('cheers');
                        setTimeout(() => {
                            Postlogin.Lesson.Popup.showCompletionModal(me);
                        }, 1000);
                    }, 100);
                }
            }, waitTime);
        };

        /**
         *  Randomly distributes a piece to the area below
         * */
        const randomizePiece = function (piece, animate = false) {
            const index = piece.attr('data-order');

            piece.attr('data-in-slot', '');

            const bgMin = 0;
            const bgMax = 100;

            const yMin = 100;
            const yMax = 200;

            const xMin = (index - 1) * -100;
            const xMax = (numberOfLetters - index) * 100;

            piece.css(
                'backgroundPosition',
                `${Math.floor(Math.random() * (bgMax - bgMin + 1) + bgMin)}% ${Math.floor(Math.random() * (bgMax - bgMin + 1) + bgMin)}%`,
            );

            if (animate) {
                // animate the piece to a random position
                piece.animate(
                    {
                        left: `${Math.floor(Math.random() * (xMax - xMin + 1) + xMin)}%`,
                        top: `${Math.floor(Math.random() * (yMax - yMin + 1) + yMin)}%`,
                        opacity: 1,
                    },
                    Math.floor(Math.random() * (1550 - 500 + 1) + 500),
                    'easeInOutQuint',
                    () => {},
                );
            } else {
                // teleport the piece to a random position
                piece.css({
                    left: `${Math.floor(Math.random() * (xMax - xMin + 1) + xMin)}%`,
                    top: `${Math.floor(Math.random() * (yMax - yMin + 1) + yMin)}%`,
                    opacity: 1,
                });
                checkOverlap(index, piece, false);
            }
        };

        const checkOverlap = function (index, piece, animate = false) {
            $(container)
                .find('.slots li > .letter.draggable')
                .each((i, aPiece) => {
                    const aIndex = $(aPiece).attr('data-order');
                    if (+aIndex === +index) {
                        return true;
                    }

                    const pieceWidth = $(piece).width();
                    const pieceHeight = $(piece).height();
                    const pieceOffset = piece.offset();
                    const pieceTop = Math.round(pieceOffset.top);
                    const pieceLeft = Math.round(pieceOffset.left);

                    const aPieceOffset = $(aPiece).offset();
                    const aPieceTop = Math.round(aPieceOffset.top);
                    const aPieceLeft = Math.round(aPieceOffset.left);

                    if (Math.abs(pieceTop - aPieceTop) <= pieceHeight / 2 && Math.abs(pieceLeft - aPieceLeft) <= pieceWidth / 2) {
                        randomizePiece(piece, animate);
                        return true;
                    }
                    return false;
                });
        };

        me.replay = function (forceShowHelp = false) {
            $(container).find('.check-order').removeClass('animated pulse_wait infinite');
            $(container).find('.slots li:not(.pre-placed)').removeClass('placed');
            $(container)
                .find('.slots li:not(.pre-placed) > .letter.correct, .slots li:not(.pre-placed) > .letter.incorrect')
                .addClass('draggable')
                .draggable('enable');
            $(container).find('.slots li:not(.pre-placed) > .letter').removeClass('placed incorrect correct glow-text');
            $(container).find('.slots li > .letter').removeClass('glow-text');

            $(container)
                .find('.slots li > .letter.draggable')
                .each((i, piece) => {
                    $(piece).removeClass('placed');
                    randomizePiece($(piece));
                });

            Postlogin.Lesson.hideNextButton();

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    me.speakQuestion(500, () => {
                        if (me.completed && !me.last) {
                            Postlogin.Lesson.showNextButton();
                        }
                    });
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        me.resize = function () {};

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
